const setIDCardPicture = (val = null) => {
  return {
    type: 'SET_IDCARDPICTURE',
    data: val,
  }
}

const setBank = (id = null, val = null) => {
  return {
    type: 'SET_BANK',
    id,
    data: val,
  }
}

const setBankAccountNumber = (val = null) => {
  return {
    type: 'SET_BANKACCOUNTNUMBER',
    data: val,
  }
}

const setBookBankPicture = (val = null) => {
  return {
    type: 'SET_BOOKBANKPICTURE',
    data: val,
  }
}

const setSignaturePicture = (val = null) => {
  return {
    type: 'SET_SIGNATUREPICTURE',
    data: val,
  }
}

export default {
  setIDCardPicture,
  setBank,
  setBankAccountNumber,
  setBookBankPicture,
  setSignaturePicture
}
